// extracted by mini-css-extract-plugin
module.exports = {"legend":"styles_legend__OfhkZ","scrollbars":"styles_scrollbars__m_Img","slideInSearchBar":"styles_slideInSearchBar__ph2QN"};